<template>
    <div>
        <div v-if="Object.keys( sorted_deviceData ).length > 0" class="report-area">

            <div class="report-area-title-tag" id="report-area-volatiles">{{ $t('report.ui.volatiles') }}</div>

            <!-- 裝置選擇按鈕 -->
            <div class="report-area-card report-select-area">
                <div class="area-overflow-x grab-bing scroll-style block-area" v-dragscroll>
                    <b-form-group>
                        <b-form-radio-group v-model="selected_device" buttons>
                            <b-form-radio v-for="( data_device, key_hashid, idx_dd) in sorted_deviceData" :key="idx_dd" :value="key_hashid" button-variant="outline-success">
                                <span v-if="deviceInfo[ key_hashid ]">{{ deviceInfo[ key_hashid ].nickname }}</span>
                                ( {{ key_hashid }} )
                            </b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </div>
            </div>

            <div class="report-area-card" v-if="selected_device">

                <b-row align-v="center">

                    <!-- CO2 -->
                    <b-col class="col-12 col-lg-8">
                        <div class="print-chart-scroll">
                            <div class="print-chart-area">
                                <MixChartMinMaxParamData v-if="arranged_data[ selected_device ].log_time" :chartID="'device-chart-' + selected_device + '-volatiles-co2'"
                                                    :info_type="'report'"
                                                    :time="arranged_data[ selected_device ].log_time['daily_mean_co2']"
                                                    :dataList="arranged_data[ selected_device ]"
                                                    :dataDisplaySettings="chartDisplaySetting[ selected_device ]['co2']"
                                                    :chartTitle="'Report Volatiles CO2'"
                                                    :showToolbox="true"
                                                    :showDeviceName="false"
                                                    :rightToolbox="false"
                                                    :xAxisName="'date'" :xAxisFormat="'MM/DD'"
                                ></MixChartMinMaxParamData>
                            </div>
                        </div>
                    </b-col>
                    <b-col class="col-12 col-lg-4">
                        <b-alert show variant="success">
                            <h4 class="">
                                <i :class="$tools.style.classIcon(deviceInfo[ selected_device ].type, 'block-title')"></i>
                                <div class="block-text">{{ deviceInfo[ selected_device ].nickname }}</div>
                                <div class="block-text">( {{ selected_device }} )</div>
                            </h4>
                            <h5>【 {{ $t('sensor.air_co2') }} ({{ $t('sensor.u_air_co2') }}) 】</h5>
                            <div>
                                <div class="block-text">{{ $t('sensor.avg_daily_low_co2') }} ：</div>
                                {{ arranged_data[ selected_device ].avg_daily_low_co2 }} {{ $t('sensor.u_avg_daily_low_co2') }}
                            </div>
                            <div>
                                <div class="block-text">{{ $t('sensor.avg_daily_high_co2') }} ：</div>
                                {{ arranged_data[ selected_device ].avg_daily_high_co2 }} {{ $t('sensor.u_avg_daily_high_co2') }}
                            </div>
                            <div>
                                <div class="block-text">{{ $t('sensor.avg_daily_co2') }} ：　　</div>
                                {{ arranged_data[ selected_device ].avg_daily_co2 }} {{ $t('sensor.u_avg_daily_co2') }}
                            </div>
                            <div>
                                <div class="block-text">{{ $t('sensor.avg_daily_diff_co2') }} ：</div>
                                {{ arranged_data[ selected_device ].avg_daily_diff_co2 }} {{ $t('sensor.u_avg_daily_diff_co2') }}
                            </div>
                        </b-alert>
                    </b-col>

                    <!-- NH3 -->
                    <b-col class="col-12 col-lg-8">
                        <div class="print-chart-scroll">
                            <div class="print-chart-area">
                                <MixChartMinMaxParamData v-if="arranged_data[ selected_device ].log_time" :chartID="'device-chart-' + selected_device + '-volatiles-nh3'"
                                                    :info_type="'report'"
                                                    :time="arranged_data[ selected_device ].log_time['daily_mean_nh3']"
                                                    :dataList="arranged_data[ selected_device ]"
                                                    :dataDisplaySettings="chartDisplaySetting[ selected_device ]['nh3']"
                                                    :chartTitle="'Report Air Humidity'"
                                                    :showToolbox="true"
                                                    :showDeviceName="false"
                                                    :rightToolbox="false"
                                                    :xAxisName="'date'" :xAxisFormat="'MM/DD'"
                                ></MixChartMinMaxParamData>
                            </div>
                        </div>
                    </b-col>
                    <b-col class="col-12 col-lg-4">
                        <b-alert show variant="success">
                            <h4 class="">
                                <i :class="$tools.style.classIcon(deviceInfo[ selected_device ].type, 'block-title')"></i>
                                <div class="block-text">{{ deviceInfo[ selected_device ].nickname }}</div>
                                <div class="block-text">( {{ selected_device }} )</div>
                            </h4>
                            <h5>【 {{ $t('sensor.air_nh3') }} ({{ $t('sensor.u_air_nh3') }}) 】</h5>
                            <div>
                                <div class="block-text">{{ $t('sensor.avg_daily_low_nh3') }} ：</div>
                                {{ arranged_data[ selected_device ].avg_daily_low_nh3 }} {{ $t('sensor.u_avg_daily_low_nh3') }}
                            </div>
                            <div>
                                <div class="block-text">{{ $t('sensor.avg_daily_high_nh3') }} ：</div>
                                {{ arranged_data[ selected_device ].avg_daily_high_nh3 }} {{ $t('sensor.u_avg_daily_high_nh3') }}
                            </div>
                            <div>
                                <div class="block-text">{{ $t('sensor.avg_daily_nh3') }} ：　　</div>
                                {{ arranged_data[ selected_device ].avg_daily_nh3 }} {{ $t('sensor.u_avg_daily_nh3') }}
                            </div>
                            <div>
                                <div class="block-text">{{ $t('sensor.avg_daily_diff_nh3') }} ：</div>
                                {{ arranged_data[ selected_device ].avg_daily_diff_nh3 }} {{ $t('sensor.u_avg_daily_diff_nh3') }}
                            </div>
                        </b-alert>
                    </b-col>

                </b-row>
            </div>

        </div>
    </div>
</template>

<script>
import { dragscroll } from 'vue-dragscroll'  // 滑鼠可拖拉 scroll 區域
import ecTools from '@/echarts/echarts-tools'
// import MixChartMultipleParams from '@/views/echarts/MixChart_MultipleParams'
import MixChartMinMaxParamData from '@/views/echarts/MixChart_MinMaxParamData'

export default {
    props: {
        deviceData: {
            type: Object,
            required: true,
        },
        deviceInfo: {
            type: Object,
            default: {},
        },
        timeData: {
            type: Object,
            default: function () { return {} }
        },
    },
    directives: {
        'dragscroll': dragscroll,
    },
    components: {
        // MixChartMultipleParams,
        MixChartMinMaxParamData,
    },
    data () {
        return {
            selected_device: undefined,
            arranged_data: {},
            chartDisplaySetting: {},
            sorted_deviceData: {},     // 排序裝置：氣象站、感測器
        }
    },
    mounted ()
    {
        this.arrangeChartDataList()
    },
    computed: {

    },
    watch: {

        deviceData (val, oldVal)
        {
            this.arrangeChartDataList()
        },

    },
    methods: {

        // 取得標準資料
        addGeneralStandards (_refreshRules)
        {
        },

        // 取得多參數圖表要用的資料設定
        getChartDisplaySetting (device_hashid, chartType)
        {
            let _device_info = this.deviceInfo[ device_hashid ]
            let _settings = []
            let _standard = {}
            this.addGeneralStandards( _standard )

            if ( chartType == 'co2' )
            {
                _settings = [
                    // 說明：sensorMapping: function (_key, _device = undefined, _default_param = undefined, showKeyName = true, _allStandard = undefined)
                    ecTools.sensorMapping( 'daily_mean_co2', _device_info, 'air_co2', true, _standard ),
                    ecTools.sensorMapping( 'daily_low_co2', _device_info, 'air_co2', true, _standard ),
                    ecTools.sensorMapping( 'daily_high_co2', _device_info, 'air_co2', true, _standard ),
                ];
                _settings[1].chart_type = 'line_area_min'
                _settings[2].chart_type = 'line_area_max'
            }
            else if ( chartType == 'nh3' )
            {
                _settings = [
                    // 說明：sensorMapping: function (_key, _device = undefined, _default_param = undefined, showKeyName = true, _allStandard = undefined)
                    ecTools.sensorMapping( 'daily_mean_nh3', _device_info, 'air_nh3', true, _standard ),
                    ecTools.sensorMapping( 'daily_low_nh3', _device_info, 'air_nh3', true, _standard ),
                    ecTools.sensorMapping( 'daily_high_nh3', _device_info, 'air_nh3', true, _standard ),
                ];
                _settings[1].chart_type = 'line_area_min'
                _settings[2].chart_type = 'line_area_max'
            }
            // console.log( _settings )
            return _settings;
        },

        // 整理資料用的，把感測器下面的資料整理成圖表要吃的格式
        appendData (data, arrangedData, dataKey)
        {
            if ( data && data[ dataKey ] != undefined )
            {
                // 要畫圖表的才會有 value 值
                if ( data[ dataKey ].value )
                {
                    arrangedData[ dataKey ] = data[ dataKey ].value

                    // 指定時間的格式才設定
                    if ( data[ dataKey ].log_time_type )
                    {
                        arrangedData.log_time[ dataKey ] = this.timeData[ data[ dataKey ].log_time_type ] // day, hour
                    }
                }
                else
                {
                    arrangedData[ dataKey ] = data[ dataKey ]
                }
            }
        },
        arrangeChartDataList ()
        {
            this.arranged_data = {}
            this.chartDisplaySetting = {}

            for ( let _devHashID in this.deviceData )
            {
                // Echarts 用資料格式整理
                let __data = this.deviceData[ _devHashID ]
                this.arranged_data[ _devHashID ] = {
                    log_time: {}
                }

                for ( let _paramsKey in __data )
                {
                    this.appendData( __data, this.arranged_data[ _devHashID ], _paramsKey )
                }


                // Echarts 圖表繪製設定
                this.chartDisplaySetting[ _devHashID ] = {}
                this.chartDisplaySetting[ _devHashID ]['co2'] = this.getChartDisplaySetting( _devHashID, 'co2' )
                this.chartDisplaySetting[ _devHashID ]['nh3'] = this.getChartDisplaySetting( _devHashID, 'nh3' )
            }

            // 排序裝置按鈕
            this.sortDeviceList()
            // console.log( this.arranged_data )
        },

        sortDeviceList ()
        {
            this.sorted_deviceData = {}
            // 先撈氣象站
            for (let hashid in this.deviceData)
            {
                if ( this.deviceInfo[ hashid ].type == 'weatherbox' )
                this.sorted_deviceData[ hashid ] = this.deviceData[ hashid ]
            }
            // 再撈感測器
            for (let hashid in this.deviceData)
            {
                if ( this.deviceInfo[ hashid ].type == 'wand' )
                this.sorted_deviceData[ hashid ] = this.deviceData[ hashid ]
            }

            // 選擇第一個裝置
            if ( Object.keys( this.sorted_deviceData ).length > 0 )
            {
                this.selected_device = Object.keys( this.sorted_deviceData )[0]
            }
        },
    }
}
</script>

<style lang="scss" scoped>

</style>
